<template>
  <div>
    <!--个人中心-->
    <div class="geren">
      <div class="left">
        <div class="shang">
          <img
            v-if="this.$cookies.get(this.$commons.User.headUrl)"
            :src="studentInfo.headUrl"
          />
          <img v-else :src="studentInfo.headUrl" />
          <p>
            {{
              this.$cookies.get(this.$commons.User.realName) ||
              this.$cookies.get(this.$commons.User.userName)
            }}
          </p>
          <!-- <router-link
            :to="{
              path: '/mine/mineInfo',
            }"
            >个人设置</router-link
          > -->
          <button
            class="logout-btn"
            v-if="canLogOff.configValue == 'true'"
            @click="logOff()"
          >
            注销
          </button>
        </div>
        <ul>
          <router-link
            :to="item.name"
            :key="index"
            v-for="(item, index) in headerList"
            v-show="
              !item.id ||
              (item.id == 1 && signInfo.normal > 0) ||
              (item.id == 2 && signInfo.sendResume > 0) ||
              (item.id == 3 && signPostList.length > 0)
            "
          >
            <li :class="{ hit: changeRed == index }" @click="reds(index)">
              <i :class="item.class"></i>
              <span>{{ item.title }}</span>
            </li>
          </router-link>
        </ul>
      </div>

      <keep-alive>
        <router-view @getUser="getUser" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeHead",
  data() {
    return {
      canLogOff: {},
      changeRed: null,
      studentInfo: {},
      enterpriseHeaderList: [],
      signInfo: {},
      signPostList:[],
      headerList: [
        {
          name: "/mine/mineMsg",
          title: "我的消息",
          class: "iconfont icon-tongzhi",
        },
        // {
        //   name: "/mine/mineResource",
        //   title: "我的文库",
        //   class: "iconfont icon-zhishi",
        // },
        {
          name: "/mine/mineInfo",
          title: "基本信息",
          class: "iconfont icon-bianji",
        },
        // {
        //   name: "/mine/mineResume",
        //   title: "我的简历",
        //   class: "iconfont icon-zhishi",
        // },
        {
          name: "/mine/mineAttachment",
          title: "我的附件",
          class: "iconfont icon-dangan",
        },
        {
          id: 1,
          name: "/mine/mineSign",
          title: "我的报名",
          class: "iconfont icon-dangan",
        },
        {
          id: 2,
          name: "/mine/mineResumeSign",
          title: "简历投递",
          class: "iconfont icon-zhishi",
        },
        {
          id: 3,
          name: "/mine/mineChoosePostSign",
          title: "岗位选岗",
          class: "iconfont icon-zhishi",
        },
        {
          name: "/mine/minePool",
          title: "人才库",
          class: "iconfont icon-zhishi",
        },
        // {
        //   name: '/mine/mineUpdatePwd',
        //   title: '修改密码',
        // }
      ],
    };
  },
  computed: {
    getSearchKey() {
      return this.$store.state.mineChangeRed;
    },
  },
  watch: {
    getSearchKey: {
      handler(newValue, oldValue) {
        this.changeRed = newValue;
      },
    },
    $route() {
      let path = this.$route.path;
      this.initChangeRed(path);
    },
  },
  mounted() {
    if (this.$store.state.mineChangeRed) {
      this.changeRed = this.$store.state.mineChangeRed;
    } else {
      this.changeRed = sessionStorage.getItem("mineChangeRed");
    }
    if (!this.changeRed || this.changeRed == "null") {
      let path = this.$route.path;
      this.initChangeRed(path);
    }
    if (this.$cookies.get(this.$commons.User.identity) == "02") {
      this.headerList = [
        {
          name: "/mine/mineMsg",
          title: "我的消息",
          class: "iconfont icon-tongzhi",
        },
        {
          name: "/mine/mineEnterprise",
          title: "我的信息",
          class: "iconfont icon-bianji",
        },
        {
          name: "/mine/mineRecruit",
          title: "我的招聘",
          class: "iconfont icon-bianji",
        },
      ];
    }
    console.log("identity", this.$cookies.get(this.$commons.User.identity));
    this.getUserInfo();
    this.getSignInfo();
    this.getPostSignInfo();
  },
  destroyed() {
    sessionStorage.removeItem("mineChangeRed");
  },
  created() {
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("mineChangeRed", this.$store.state.mineChangeRed);
    });
    this.isLogOff();
  },
  methods: {
    initChangeRed(path) {
      console.log("path", path);
      for (let i = 0; i < this.headerList.length; i++) {
        if (path == this.headerList[i].name) {
          this.changeRed = i;
          break;
        }
      }
    },
    reds(index) {
      this.changeRed = index;
      this.$store.dispatch("setMineChangeRed", index);
    },
    getUserInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.studentInfo = res.data;
            _this.$cookies.set(
              _this.$commons.User.userName,
              _this.studentInfo.name
            );
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => { })
        .finally(() => { });
    },
    getSignInfo() {
      let _this = this;
      _this.$api.employee
        .getSignInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            console.log("123", res);
            _this.signInfo = res.data;
          }
        })
        .catch(() => { })
        .finally(() => { });
    },
    getPostSignInfo(){
      let _this = this;
      let search= {
        pageNum: 1,
        pageSize: 3,
      }
      _this.$api.choosePostRecruitNotice
        .getChoosePostSignList(search)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.signPostList = res.rows;
          }
        })
        .catch(() => {});
    },
    getUser(data) {
      let _this = this;
      _this.studentInfo = data;
    },
    isLogOff() {
      let _this = this;
      _this.$api.user
        .isLogOff(6)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.canLogOff = res.data;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => { })
        .finally(() => { });
    },
    logOff() {
      let _this = this;
      _this.$layer.confirm(
        "注销后将无法登录,是否继续?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$api.user
            .logOff()
            .then((res) => {
              if (res.code == _this.$commons.RespCode.success) {
                console.log("123");
                _this.$cookies.remove(_this.$commons.User.Authentication);
                _this.$cookies.remove(_this.$commons.User.userName);
                _this.$cookies.remove(_this.$commons.User.identity);
                _this.$router.push({
                  path: "/",
                });
              } else {
                _this.$layer.alert(res.msg);
              }
            })
            .catch(() => { })
            .finally(() => {
              _this.$layer.close(index);
            });
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
  },
};
</script>

<style>
.logout-btn {
  display: inline-block;
  padding: 1px 15px;
  background-color: #ff4d4d;
  color: #fff;
  border-radius: 15px;
  text-decoration: none;
  text-align: center;
  font-size: 16px;
  transition: background-color 0.3s ease;
  margin-bottom: 10px;
}

.logout-btn:hover {
  background-color: #ff1a1a;
}

.logout-btn:active {
  background-color: #b31313;
}
</style>



// WEBPACK FOOTER //
// src/view/mine/mine.vue